import * as React from "react";
import type { SVGProps } from "react";
const SvgPostcode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      d="M8.642 7.141a2.53 2.53 0 0 0-2.525 2.525v4.84h5.05v-4.84a2.53 2.53 0 0 0-2.525-2.525m1.15 3.488H7.409a.562.562 0 1 1 0-1.125h2.385a.563.563 0 1 1 0 1.125m8.09-.963v4.84h-5.59v-4.84c0-.98-.388-1.869-1.018-2.525h4.084a2.53 2.53 0 0 1 2.525 2.525m-5.59 5.966h.982v1.977h-.982zM12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m7.008 15.07c0 .31-.252.562-.563.562H14.4v2.54c0 .31-.251.562-.562.562H11.73a.563.563 0 0 1-.563-.562v-2.54H5.555a.56.56 0 0 1-.563-.563V9.666a3.654 3.654 0 0 1 3.65-3.65h6.716a3.654 3.654 0 0 1 3.65 3.65z"
    />
  </svg>
);
export default SvgPostcode;
